import React from 'react';

const Videos = () => {
  return (
    <div>
      {/* Breadcrumb Section */}
      <section
        className="breadcrumb-main pb-20 pt-14"
        style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}
      >
        <div
          className="section-shape section-shape1 top-inherit bottom-0"
          style={{ backgroundImage: 'url(images/shape8.png)' }}
        ></div>
        <div className="breadcrumb-outer">
          <div className="container">
            <div className="breadcrumb-content text-center">
              <h2 className="mb-3 text-white">Videos</h2>
            </div>
          </div>
        </div>
        <div className="dot-overlay"></div>
      </section>

      {/* Video Section */}
      <div style={{ textAlign: 'center', padding: '40px 0' }}>
        {/* Local MP4 Video */}
        <div
          style={{
            maxWidth: '800px',
            margin: '0 auto 40px',
            position: 'relative',
          }}
        >
          <video
            width="100%"
            height="auto"
            controls
            loop
            style={{
              borderRadius: '10px',
              boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
            }}
          >
            <source src="/images/video.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        {/* YouTube Embed (loop + no suggestions) */}
        <div
          style={{
            position: 'relative',
            paddingBottom: '56.25%',
            height: 0,
            overflow: 'hidden',
            maxWidth: '800px',
            margin: '0 auto',
            borderRadius: '10px',
            boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
          }}
        >
          <iframe
            src="https://www.youtube.com/embed/HXJW_c0h0MM?rel=0&loop=1&playlist=HXJW_c0h0MM"
            title="YouTube Shorts video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
            }}
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default Videos;
